import PaymentTypePage from './PaymentTypePage';

export default PaymentTypePage;
